import { render, staticRenderFns } from "./ImportWhite.vue?vue&type=template&id=0a7d147d&scoped=true&"
import script from "./ImportWhite.vue?vue&type=script&lang=js&"
export * from "./ImportWhite.vue?vue&type=script&lang=js&"
import style0 from "./ImportWhite.vue?vue&type=style&index=0&id=0a7d147d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d147d",
  null
  
)

export default component.exports